<template>
  <div class="sidebar-wrapper">
    <b-sidebar
      position="fixed"
      :reduce="isReduced"
      :fullwidth="isFullwidth"
      :open.sync="sidebarOpenned"
      :right="isRight"
      :overlay="hasOverlay"
      :canCancel="hasCanCancel"
      class="sidebar"
    >
      <div class="navigation">
        <div class="spacing-p-10">
          <span class="collapse-menu" @click="expandButton">
            <b-tooltip
              :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
              size="is-large"
              :position="isReduced ? 'is-right' : 'is-bottom'"
              :label="isReduced ? General.EXPAND_MENU : General.COLLAPSE_MENU"
            >
              <b-icon
                icon="menu-open"
                :type="isContrast ? 'is-white-dark' : 'is-blue-oil'"
              />
            </b-tooltip>
          </span>
          <Menu
            :isReduced="isReduced"
            :handlerReduce="value => handlerSidebar(value)"
            @click.native="closeSidebar"
          />
        </div>
        <div v-if="!inAdmRouter">
          <a
            v-if="!isReduced"
            class="side-bar-help-center"
            href="https://suite.seplag.ce.gov.br/"
            target="_blank"
            rel="noopener"
          >
            <b-icon
              class="icon-help-center"
              icon="help-circle"
              customClass="custom-size"
            />
            <span class="has-text-weight-bold has-text-centered">
              {{ App.Channel.HELP_CENTER }}
            </span>
          </a>
          <div
            v-if="!isReduced"
            class="side-bar-footer spacing-p-10"
            @click="openModalPartnership"
          >
            <img
              :src="
                isContrast
                  ? require('@/assets/images/SUITE_WORD_WHITE.png')
                  : require('@/assets/images/SUITE_LOGO.png')
              "
              width="50"
              alt=""
            />
            <div>
              <p
                v-if="version && version.date"
                class="is-size-7 has-text-weight-semibold"
              >
                {{ App.ModalPartnership.VERSION }}: {{ version.version }}
              </p>
              <p class="is-size-7">
                {{ `${Home.ACCESS} ${getSessionTime}` }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

import Menu from "@/views/App/Menu/Menu.vue";
import ModalPartnership from "@/views/App/ModalPartnership";
import { App, General, Home } from "@/utils/constants";
import { addZero } from "@/utils/timeUtility";

export default {
  name: "SideBar",

  components: {
    Menu
  },

  data() {
    return {
      App,
      General,
      Home,
      currentDate: new Date(),
      interval: null,
      isReduced: false,
      isReduceDisable: false,
      isFullwidth: false,
      isRight: false,
      isMobile: false,
      hasOverlay: false,
      hasCanCancel: true,
      siteSeplagCALink: Home.SEPLAG_HELP_CENTER_SITE_LINK
    };
  },

  computed: {
    ...mapGetters({
      sessionTime: "sessionTime",
      isContrast: "isContrast",
      version: "getLastVersion",
      isSidebarOpenned: "isSidebarOpenned"
    }),

    sidebarOpenned: {
      get() {
        return this.isSidebarOpenned;
      },
      set(value) {
        this.setSidebar(value);
      }
    },

    getSessionTime() {
      const hours =
        Math.floor(this.sessionTime(this.currentDate) / (1000 * 60 * 60)) % 24;
      const minutes = Math.floor(
        (this.sessionTime(this.currentDate) / (1000 * 60)) % 60
      );
      const seconds = Math.floor(
        (this.sessionTime(this.currentDate) / 1000) % 60
      );
      return `${addZero(hours + minutes)}min ${addZero(seconds)}s`;
    },

    inAdmRouter() {
      return (
        this.$route.path?.startsWith("/app/admin") ||
        this.$route.query.isAdmBookmark
      );
    }
  },

  watch: {
    inAdmRouter() {
      this.onResize();
    }
  },

  beforeMount() {
    this.onResize();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },

  mounted() {
    this.interval = setInterval(() => (this.currentDate = new Date()), 1000);
    this.emitMargin();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    clearInterval(this.interval);
  },

  methods: {
    ...mapMutations({
      setSidebar: "setSidebar"
    }),
    getBrowserWidth() {
      if (window.innerWidth < 768) {
        return "xs";
      } else if (window.innerWidth < 991) {
        return "sm";
      } else if (window.innerWidth < 1199) {
        return "md";
      } else {
        return "lg";
      }
    },
    onResize() {
      const browserWidth = this.getBrowserWidth();
      if (browserWidth === "xs") {
        this.isRight = true;
        this.isFullwidth = false;
        this.isMobile = true;
        this.setSidebar(false);
        this.hasOverlay = true;
        this.isReduced = false;
        this.hasCanCancel = true;
      } else {
        this.isRight = false;
        this.isFullwidth = false;
        this.isMobile = false;
        this.setSidebar(true);
        this.hasOverlay = false;
        this.hasCanCancel = false;
        if (browserWidth === "sm") {
          this.isReduced = true;
          this.isReduceDisable = true;
        } else if (browserWidth === "md" || browserWidth === "lg") {
          this.isReduced = false;
          this.isReduceDisable = false;
        }
      }
      this.emitMargin();
    },
    handlerSidebar(value) {
      this.isReduced = false;
      this.isReduceDisable = value;
    },
    expandButton() {
      if (!this.isReduceDisable) this.isReduced = !this.isReduced;
      this.emitMargin();
    },
    emitMargin() {
      let margin = {};
      if (this.getBrowserWidth() === "xs") {
        margin = { "margin-left": "0px" };
      } else {
        if (this.isReduced) {
          margin = { "margin-left": "80px" };
        } else {
          margin = { "margin-left": "14vw" };
        }
      }
      this.$emit("update:view-container-margin", margin);
    },
    openModalPartnership() {
      this.$buefy.modal.open({
        parent: this,
        component: ModalPartnership,
        hasModalCard: true,
        trapFocus: true
      });
    },
    closeSidebar() {
      if (this.getBrowserWidth() === "xs") {
        this.setSidebar(false);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables";

.sidebar-wrapper {
  z-index: 2000;
}

.navigation {
  background-color: $color-1;
  box-shadow: 0px 5px 5px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
  display: flex;
  flex-direction: column;
  height: calc(100vh - 85px);
  align-items: stretch;
  justify-content: space-between;
  margin-top: 85px;
}

.header {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  font-weight: 600;
  padding-bottom: 5px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 10px;
  cursor: pointer;
  &:hover {
    color: $blue-oil;
    border-color: $blue-oil;
  }
}

.card {
  box-shadow: none;
}

.card-content {
  padding: 15px 10px 0 10px;
}

.image {
  padding-left: 5px;
}

.collapse-menu {
  display: flex;
  cursor: pointer;
  justify-content: flex-end;
  padding: 5px 10px;
}

.footer-nav {
  position: fixed;
  bottom: 0px;
  height: 50px;
  width: 100%;
  background-color: $color-1;
  box-shadow: 0 -1px 3px 0px rgba(10, 10, 10, 0.2);
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  display: flex;

  * {
    cursor: pointer;
  }
}
.side-bar-footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: $color-7;
  background-color: $color-2;
  margin: 0 10px;
  margin-bottom: 20px;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    color: $primary;
  }
}
.side-bar-help-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: $color-7;
  background-color: $color-2;
  margin: 0 10px;
  margin-bottom: 20px;
  border: 5px solid $color-2;
  border-radius: 5px;
  padding: 0 15px 10px;
  cursor: pointer;
  &:hover {
    border-color: $color-7;
  }
}

.icon-help-center {
  margin: 40px 0;
}
</style>

<style lang="scss">
.sidebar-content {
  max-width: 14vw;

  @media only screen and (max-width: 767px) {
    max-width: 45vw;
  }
}

.side-bar-help-center .custom-size::before {
  font-size: 64px !important;
}
</style>
